import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Events from './pages/Events';
import Results from './pages/Results';
import Gallery from './pages/Gallery';
import Brochure from './pages/Brochure';
import Admin from './pages/Admin';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import ScrollAnimation from './components/common/ScrollAnimation';
import DancingAnimation from './components/common/DancingAnimation';
import './styles/themes.css';

const MainScrollPage = () => {
  return (
    <>
      <ScrollAnimation />
      <DancingAnimation />
      <div className="firefly-bg">
        <Home />
        <Events />
      </div>
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<MainScrollPage />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/results" element={<Results />} />
            <Route path="/brochure" element={<Brochure />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;